import type { ConditionalOperator } from "@repo/shared";
import { SelectItem } from "@/components/ui/select";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./scalar-operator-items.i18n";

/**
 * Operator menu entries for a scalar condition source, in the order
 * `scalarConditionOperators` returns them. Shared by the flow editor and the
 * three PDF condition dialogs; the operator names are the same for all of
 * them, so the component owns them.
 */

const LABEL_KEY: Partial<Record<ConditionalOperator, keyof (typeof T)["en_GB"]>> = {
  equals: "equals",
  not_equals: "notEquals",
  greater_than: "greaterThan",
  less_than: "lessThan",
  is_empty: "isEmpty",
  is_not_empty: "isNotEmpty",
};

type ScalarOperatorItemsProps = {
  operators: readonly ConditionalOperator[];
};

export function ScalarOperatorItems({ operators }: ScalarOperatorItemsProps) {
  const t = useT(T);
  return (
    <>
      {operators.map((operator) => {
        const key = LABEL_KEY[operator];
        return key ? (
          <SelectItem key={operator} value={operator}>
            {t[key]}
          </SelectItem>
        ) : null;
      })}
    </>
  );
}
